



































































































































import { DeleteIcon, EditIcon, PlayCircleStrokeIcon, PauseCircleFilledIcon, HelpCircleIcon } from 'tdesign-icons-vue';
import { DialogInstance, DialogPlugin } from 'tdesign-vue';
import { defineComponent, ref, toRefs, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';

// 引入工具类
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import IPRestrictionListHandler, { IPRestrictionViewData } from '../composiiton/IPRestrictionListHandler';
import IPRestrictionSubmitHandler from '../composiiton/IPRestrictionSubmitHandler';
import IPRestrictionConfig, { IPRestrictionConfigInfo } from './IPRestrictionConfig.vue';

export default defineComponent({
  components: {
    DeleteIcon,
    EditIcon,
    PlayCircleStrokeIcon,
    PauseCircleFilledIcon,
    HelpCircleIcon,
    IPRestrictionConfig,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { columns, pageData, tableData, loading, ipAdminStatus, methods: listMethods } = IPRestrictionListHandler();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const { itemInfo, createRestriction, modifyRestriction, editRestrictionState, deleteRestriction } =
      IPRestrictionSubmitHandler();
    const showIPConfig = ref(false);
    const methods = {
      async configDidSubmit(type: 'add' | 'edit', configInfo: IPRestrictionConfigInfo) {
        let succeed = true;
        if (type === 'add') {
          succeed = await createRestriction(configInfo.ipString);
          if (succeed) {
            reporter.report('domain_manage', {
              result: 'domain_success',
            });
          }
          if (tableData.list.length === 0) {
            // 第一次新增时需要同时上报管理员状态
            try {
              await smh.userAPI.modifyIPAdminStatus({
                limitAdmin: !ipAdminStatus.value,
              });
            } catch (e: any) {
              tips.error(e as MsgError);
              return;
            }
          }
        } else if (type === 'edit' && configInfo.itemID) {
          succeed = await modifyRestriction(configInfo.itemID, configInfo.ipString);
        }
        if (succeed) {
          showIPConfig.value = false;
          listMethods.pullList();
        }
      },
      onOperateEventProxy(command: string, row: IPRestrictionViewData) {
        switch (command) {
          case 'delete':
            reporter.report('domain_manage', {
              command: 'delete',
            });
            this.deleteRestriction(row);
            break;
          case 'active': {
            reporter.report('domain_manage', {
              command: 'recover',
            });
            this.editRestrictionState(row, true);
            break;
          }
          case 'deactive': {
            reporter.report('domain_manage', {
              command: 'stop',
            });
            this.editRestrictionState(row, false);
            break;
          }
          case 'edit': {
            reporter.report('domain_manage', {
              command: 'edit',
            });
            itemInfo.value = row.item;
            showIPConfig.value = true;
            break;
          }
          default:
            break;
        }
      },
      async editRestrictionState(row: IPRestrictionViewData, enable: boolean) {
        let succeed = true;
        succeed = await editRestrictionState(row.item.id, enable);
        if (succeed) {
          row.item.enabled = enable;
          row.activeState = row.item.enabled ? i18n_t('生效中') : i18n_t('未生效');
        }
      },
      async deleteRestriction(row: IPRestrictionViewData) {
        const confirmDialog: DialogInstance = CustomDialog.confirm({
          header: i18n_t('温馨提醒'),
          body: h => {
            const baseTip = h('p', i18n_t('删除后规则将清除并永久失效'));
            return h('div', [baseTip]);
          },
          theme: 'warning',
          onConfirm: async () => {
            let succeed = true;
            succeed = await deleteRestriction(row.item.id);
            if (succeed) {
              listMethods.pullList();
            }
            if (confirmDialog.hide) {
              confirmDialog.hide();
            }
          },
          onClose: ({ e, trigger }) => {
            if (confirmDialog.hide) {
              confirmDialog.hide();
            }
          },
        });
      },
      openIPConfig() {
        itemInfo.value = {};
        showIPConfig.value = true;
        reporter.report('domain_manage', {
          result: 'domain_add',
        });
      },
      didClickIPSwitch() {
        try {
          reporter.report('domain_manage', {
            admin_switch: ipAdminStatus.value === true ? 'open' : 'close',
          });
          smh.userAPI.modifyIPAdminStatus({
            limitAdmin: !ipAdminStatus.value,
          });
        } catch (e: any) {
          tips.error(e as MsgError);
          ipAdminStatus.value = !ipAdminStatus.value;
        }
      },
    };
    reporter.report('domain_manage', {
      result: 'domain_manage_show',
    });
    return {
      columns,
      ipAdminStatus,
      loading,
      ...toRefs(tableData),
      ...toRefs(pageData),
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      listOperateMethods,
      listMethods,
      showIPConfig,
      itemInfo,
      ...methods,
    };
  },
});
